/**
 * Expression Sorting Business Rules
 *
 * Defines the sorting logic for expressions in the Product Matrix.
 * These rules can be configured and modified without changing component code.
 */
export const EXPRESSION_SORT_RULES = [
    {
        priority: 1,
        matchKeyword: 'Launch',
        description: 'Launch expressions appear first'
    }
];
export function sortExpressionsByBusinessRules(expressions) {
    return [...expressions].sort((a, b) => {
        const aPriority = getExpressionPriority(a.expressionName);
        const bPriority = getExpressionPriority(b.expressionName);
        if (aPriority !== bPriority) {
            return aPriority - bPriority;
        }
        return a.expressionName.localeCompare(b.expressionName);
    });
}
function getExpressionPriority(expressionName) {
    for (const rule of EXPRESSION_SORT_RULES) {
        if (expressionName.includes(rule.matchKeyword)) {
            return rule.priority;
        }
    }
    return 999;
}
